"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhaseName = exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["FMP"] = "first-meaningful-paint";
    InteractionName["LoadExperiments"] = "load-experiments";
    InteractionName["LoadWidgetSettings"] = "load-widget-settings";
    InteractionName["LoadPaymentMethods"] = "load-payment-methods";
    InteractionName["PayPalLoadScript"] = "paypal-load-script";
    InteractionName["PayPalCreateOrder"] = "paypal-create-order";
    InteractionName["PayPalOnPaymentAuthorizedFetchData"] = "paypal-on-payment-authorized-fetch-data";
    InteractionName["PayPalUpdateOrder"] = "paypal-update-order";
    InteractionName["ApplePayValidateMerchant"] = "apple-pay-validate-merchant";
    InteractionName["GooglePayLoadOptions"] = "google-pay-load-options";
    InteractionName["GooglePayOnPaymentAuthorizedLoadData"] = "google-pay-on-payment-authorized-load-data";
})(InteractionName || (exports.InteractionName = InteractionName = {}));
var PhaseName;
(function (PhaseName) {
    PhaseName["LoadMainBundle"] = "load-main-bundle";
    PhaseName["LoadSettings"] = "load-preload-data";
})(PhaseName || (exports.PhaseName = PhaseName = {}));
//# sourceMappingURL=InteractionName.js.map